import React, { useEffect, useReducer } from 'react';
import { CartContext } from '@/react/store/context';
import reducer, { defStore, rewriteCart } from '@/react/store/reducer';
import CalcCart from '@/react/temps/CalcCart';
import { createRoot } from 'react-dom/client';
import { DM_EVENT } from '@shared/data';
import LocalCart from '@/class/LocalCart';
const CartTemplate = () => {
    const store = useReducer(reducer, Object.assign(Object.assign({}, defStore), { cart: LocalCart.list }));
    function onChangeOutCart() {
        store[1](rewriteCart(LocalCart.list));
    }
    useEffect(() => {
        window.addEventListener(DM_EVENT.update, onChangeOutCart);
        return () => {
            window.removeEventListener(DM_EVENT.update, onChangeOutCart);
        };
    }, []);
    return (React.createElement(CartContext.Provider, { value: store },
        React.createElement(CalcCart, null)));
};
function renderCartTemplate() {
    const node = document.getElementById('calcZV_cart__react');
    if (!node)
        throw new Error('Ошибка инициализации корзины!');
    const root = createRoot(node);
    root.render(React.createElement(CartTemplate, null));
}
export default renderCartTemplate;
